<div
  [class.active]="isSmallMenu"
  class="menu">
  <div class="menu__header">
    <img
      [class.active]="isSmallMenu"
      src="assets/img/logo.svg"
      alt="logo"
      class="menu__header-logo" />

    <img
      [class.active]="!isSmallMenu"
      src="assets/img/logo-small.svg"
      alt="Logo small"
      class="menu__header-logo" />

    <button
      [class.active]="isSmallMenu"
      (click)="toggleMenu()"
      class="menu__header-toggle">
      <img
        src="assets/img/menu-arrow.svg"
        alt="Menu arrow"
        class="icon" />
    </button>
  </div>
  <div class="menu__body">
    <div class="menu__body-top">
      <app-navigation [isSmallMenu]="isSmallMenu"> </app-navigation>
    </div>
    <div class="menu__body-bottom">
      <nav class="navigation">
        <ul
          [class.active]="isSmallMenu"
          class="navigation__list">
          <li
            routerLink="/profile"
            routerLinkActive="active"
            class="navigation__list-item">
            <span class="icon-profile">{{ fistLetterName }}</span>
            <span class="name">{{ "NAVIGATION.PROFILE_USER" | translate }}</span>
          </li>
          <li
            *appHasAccess="['SUPPORT_VIEW']"
            routerLink="/support"
            routerLinkActive="active"
            class="navigation__list-item">
            <img
              src="assets/img/support-icon.svg"
              alt="icon"
              class="icon" />
            <span class="name">{{ "NAVIGATION.SUPPORT" | translate }}</span>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>
